
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.065","height":"15.857"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"transform":"translate(1 1.07)"}},[_c('path',{staticClass:"a",attrs:{"d":"M12.065 13.786v-1.508a3.016 3.016 0 00-3.016-3.016H3.016A3.016 3.016 0 000 12.278v1.508"}}),_c('circle',{staticClass:"a",attrs:{"cx":"3","cy":"3","r":"3","transform":"translate(3.032 -.07)"}})])])
          )
        }
      }
    